import SharedLayouts from "../Layouts/SharedLayout";
import * as rsuite from 'rsuite';
import { HiPlusCircle, HiPencilAlt, HiOutlineTrash, HiOutlineCheck, HiOutlineXCircle } from "react-icons/hi";
import {
  useReactTable,
  getCoreRowModel
} from "@tanstack/react-table";
import useToaster from 'rsuite/useToaster';
import React, { useEffect, useState, useRef } from "react";
import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import * as General from '../../src/General/General';
import { ImCheckmark } from "react-icons/im";
import { useNavigate } from "react-router-dom";
axios.defaults.withCredentials = true;

function previewFile(file, callback) {
    const reader = new FileReader();
    reader.onloadend = () => {
        callback(reader.result);
    };
    reader.readAsDataURL(file);
}
const Text = () => {
    //#region handler
    const Title_Change = (e, id) => {
        let tmp = [...Contents];
        let index = Contents.findIndex(x => x.Id === id);
        if(index !== -1){
            tmp[index].Title = e;
        }
        setContents(tmp);
    }
    const Content_Change = (e, id) => {
        let tmp = [...Contents];
        let index = Contents.findIndex(x => x.Id === id);
        if(index !== -1){
            tmp[index].Content = e;
        }
        setContents(tmp);
    }
    //#endregion

    //#region const
    const navigate = useNavigate();
    const [Contents, setContents] = useState([]);
    const toaster = useToaster();
    const inputFile = useRef(null);
    const [Image, setImage] = useState("");
    const [ImageName, setImageName] = useState("");
    const [Content, setContent] = useState("");
    const [Order, setOrder] = useState(0);
    const [Title, setTitle] = useState("");
    const [CurrentContentId, setCurrentContentId] = useState(General.GuidEmpty());
    const [ErrorMsg, setErrorMsg] = useState("");
    //#endregion
    //#region method
    const clearDependecies = () => {
        setContent("");
        setTitle("");
        setImage("");
        setImageName("");
        setCurrentContentId(General.GuidEmpty());
        handleReset();
    }

    const ImageCheck = (e) => {
        setImage(e.target.files[0]); // Set the file to Image state
        setImageName(e.target.files[0].name);
    }
    const handleReset = () => {
        if (inputFile.current) {
            inputFile.current.value = "";
            inputFile.current.type = "text";
            inputFile.current.type = "file";
        }
    };
    const CheckValidation = (type, text) => {
        if (type === 0 && !Image && !text.FileName) {
            toaster.push(General.ShowMessage('error', 'لطفا عکس را وارد کنید'), 'topCenter');
            return false;
        }
        else {
            return true;
        }
    };

    const Save = (id) => {
        const text = Contents.find(x => x.Id === id);
        if (!text) {
            toaster.push(General.ShowMessage('error', 'محتوا یافت نشد'), 'topCenter');
            return;
        }
        const isValid = CheckValidation(text.Type, text);
        if (isValid) {
            setErrorMsg("");
            const formData = new FormData();
            formData.append('FormFile', Image);
            formData.append('FileName', ImageName || text.FileName);
            formData.append('Title', text.Title);
            formData.append('Content', text.Content);
            formData.append('Id', id);
            formData.append('PrevFileName', text.PrevFileName === null ? "" : text.PrevFileName);
            formData.append('Order', Order || text.Order);
            formData.append('Type', text.Type);
            const requestOptions = {
                url: General.ApiRoot() + '/text/update',
                method: "post",
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    ...General.AuthHeader(),
                },
            };

            trackPromise(
                axios(requestOptions)
                    .then(result => {
                        toaster.push(General.ShowMessage('success', 'عملیات با موفقیت انجام شد'), 'topCenter');
                        GetAll(); // Refresh data
                        clearDependecies(); // Clear form fields
                    })
                    .catch(error => {
                        const msg = error?.response?.data?.message || 'عملیات با خطا مواجه شد';
                        setErrorMsg(msg);
                        toaster.push(General.ShowMessage('error', msg), 'topCenter');
                    })
            );
        }
    };

    const GetAll = () => {
        const RequestOption = {
            url: General.ApiRoot() + '/text/getAll',
            method: "get",
        };

        trackPromise(
            axios(RequestOption)
                .then((result) => {
                    if (result.data) {
                        setContents(result.data); // Ensure result.data is defined
                    } else {
                        throw new Error('No data returned from API');
                    }
                })
                .catch((error) => {
                    toaster.push(
                        General.ShowMessage('error', 'خطا در برقراری ارتباط با سرور'),
                        'topCenter'
                    );
                })
        );
    };

    //#endregion
    useEffect(() => {
        // Check if the user is authenticated
        if (!General.isLoggedIn()) {
            navigate('/'); // Redirect to login if not authenticated
        }
        else {
            GetAll();
        }
    }, []);

    return (
        <SharedLayouts>
            <div className="h-16 bg-white mb-2 rounded-md px-5 items-center flex">
                <rsuite.Text size="lg">محتواهای ثابت</rsuite.Text>
            </div>
            {ErrorMsg && (
                <div className="px-3 mb-2">
                    <rsuite.Message type="error" showIcon closable onClose={() => setErrorMsg("")}>
                        {ErrorMsg}
                    </rsuite.Message>
                </div>
            )}
            <div className=" rounded-md px-3">

                {
                    Contents.map(item => (
                        <rsuite.Card key={item.Id} shaded direction="row" className="my-3">
                            <div className="p-2">
                                <rsuite.Image
                                    rounded
                                    src={item.ImageURL}
                                    alt="بدون عکس"
                                    width={160}
                                    fallbackSrc="https://placehold.co/300x200"
                                />
                            </div>

                            <rsuite.VStack spacing={2} className="w-100">
                                <rsuite.Card.Header as="h5">{item.TypeTitle}</rsuite.Card.Header>
                                <rsuite.Card.Body className="w-100">
                                    <rsuite.Text muted>عنوان محتوا</rsuite.Text>
                                    <rsuite.Input className="mt-2" value={item.Title} onChange={(e) => Title_Change(e, item.Id)} />
                                    <rsuite.Input as="textarea" rows={9} className="w-[100%] mt-2" value={item.Content} onChange={(e) => Content_Change(e, item.Id)} />
                                </rsuite.Card.Body>
                                <rsuite.Card.Footer className="w-100">
                                    <rsuite.Row className="w-100">
                                        <rsuite.Col xs={12}>
                                            <rsuite.Whisper trigger="hover" speaker={<rsuite.Tooltip>آپلود عکس جدید</rsuite.Tooltip>}>
                                                <rsuite.Input
                                                    guid={false}
                                                    placeholder="آپلود عکس جدید"
                                                    onInput={ImageCheck}
                                                    ref={inputFile}
                                                    type="file" />
                                            </rsuite.Whisper>
                                        </rsuite.Col>
                                        <rsuite.Col xs={12} className="text-left">
                                            <rsuite.Button onClick={() => Save(item.Id)} appearance="primary" color="cyan">
                                                ذخیره تغییرات
                                            </rsuite.Button>
                                        </rsuite.Col>
                                    </rsuite.Row>
                                </rsuite.Card.Footer>
                            </rsuite.VStack>
                        </rsuite.Card>
                    ))
                }
            </div>
        </SharedLayouts>
    )


}
export default Text;
